import { usePlayerContainer } from './usePlayerContainer';

export const useVideoElement = () => {
  const playerContainer = usePlayerContainer();

  return playerContainer.querySelector<HTMLVideoElement>('video.jw-video');
};
